import { useEffect, useMemo, useState, useCallback } from "react";
import { jwtDecode } from "jwt-decode";
import { getUserById } from "../api/User/userApi";
import {
  filterRowsByProveedorPermitidos,
  parseProveedoresPermitidos,
} from "../utils/proveedorPermissionsUtils";

export const useProveedorPermissions = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadUser = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const decoded = jwtDecode(token);
        const user = await getUserById(decoded.userId);
        setUserData(user);
      } catch (err) {
        console.error("Error loading user:", err);
      } finally {
        setLoading(false);
      }
    };

    loadUser();
  }, []);

  const proveedoresPermitidos = useMemo(
    () => parseProveedoresPermitidos(userData?.ProveedoresPermitidos),
    [userData],
  );

  const hasProveedorLimit =
    Array.isArray(proveedoresPermitidos) && proveedoresPermitidos.length > 0;

  const filterByProveedor = useCallback(
    (rows = []) => filterRowsByProveedorPermitidos(rows, proveedoresPermitidos),
    [proveedoresPermitidos],
  );

  return {
    loading,
    hasProveedorLimit,
    proveedoresPermitidos,
    filterByProveedor,
  };
};
